module.exports = __webpack_public_path__ + "static/media/img_product_title.dee75362.png";